/**
 * Resolves USDC token address for Treydorex sale (chain-agnostic env name).
 * Priority: TRDX-specific → mainnet alias → legacy Sepolia key (backward compatible).
 */

export const TRDX_USDC_ENV_KEYS = [
  "REACT_APP_TRDX_USDC_ADDRESS",
  "REACT_APP_MAINNET_USDC_ADDRESS",
  "REACT_APP_SEPOLIA_USDC_ADDRESS",
];

/** @returns {string} First non-empty env value, or "" */
export function resolveTrdxUsdcAddressFromEnv(env = process.env) {
  for (const key of TRDX_USDC_ENV_KEYS) {
    const v = String(env[key] ?? "").trim();
    if (v) return v;
  }
  return "";
}

/** @returns {string | null} Env key that supplied the address, or null */
export function resolveTrdxUsdcEnvKeyUsed(env = process.env) {
  for (const key of TRDX_USDC_ENV_KEYS) {
    const v = String(env[key] ?? "").trim();
    if (v) return key;
  }
  return null;
}
